module.exports = __webpack_public_path__ + "media/images/icon__betPick--censored-3bcaf37bc0f2be0185fb4c9345ed8a16.png";